// GLOBAL platform feature flags — one level above account.features.
//
// Shape: { flags: Record<string, boolean>, ... }
// Reads come exclusively via the useFeatureFlag hook. New flags appearing
// on the server show up here automatically; the hook + the registry on
// the backend are the only places that know flag keys.
//
// Defaults: when the backend hasn't responded yet, all reads return TRUE
// (preserves current behavior — features stay visible until we hear
// otherwise, matching the migration's NOT NULL DEFAULT TRUE for shipped
// surfaces). Once the first fetch lands, we trust the server's values.

import { SET_FEATURE_FLAGS, SET_FEATURE_FLAGS_LOADING, CLEAR_ALL } from '../constants';

export interface FeatureFlagsState {
  flags: Record<string, boolean>;
  fetched: boolean;
  fetching: boolean;
  fetchedAt: number | null;
}

const initialState: FeatureFlagsState = {
  flags: {},
  fetched: false,
  fetching: false,
  fetchedAt: null,
};

const featureFlagsReducer = (
  state: FeatureFlagsState = initialState,
  { type, payload }: { type: string; payload?: any },
): FeatureFlagsState => {
  switch (type) {
    case SET_FEATURE_FLAGS_LOADING:
      return { ...state, fetching: Boolean(payload) };
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        flags: payload?.flags ?? {},
        fetched: true,
        fetching: false,
        fetchedAt: Date.now(),
      };
    case CLEAR_ALL:
      // Keep flags across logout — they're platform-global, not user data.
      // Resetting on logout would force every fresh login to render a brief
      // "everything disabled" flash before the next fetch resolved.
      return state;
    default:
      return state;
  }
};

export default featureFlagsReducer;
